export default {
  currentName: '后台管理系统',
  total: '总数',
  date: '日期',
  search: '搜索',
  clear: '清除',
  reset: '重置',
  create: '新增',
  edit: '编辑',
  delete: '删除',
  batchDelete: '批量删除',
  inputPleaseEnter: '请输入',
  inputPleaseSelect: '请选择',
  createTitle: '新增{{title}}',
  editTitle: '编辑{{title}}',
  pleaseEnter: '请输入{{name}}',
  pleaseSelect: '请选择{{name}}',
  confirmMessage: '确定要{{name}}吗？',
  deleteConfirmMessage: '确定要删除{{name}}吗？',
  batchDeleteConfirmMessage: '确定要批量删除{{name}}吗？',
  successfulOperation: '操作成功',
  successfullyDeleted: '删除成功',
  checkAll: '全选',
  checkAllWarning: '表格筛选必须勾选一个',
  fullScreen: '全屏',
  exitFullscreen: '退出全屏',
  themes: '主题模式',
  changePassword: '修改密码',
  signOut: '退出登录',
  signOutMessage: '是否确定退出系统？',
  kindTips: '温馨提示',
  reload: '重新加载',
  closeTab: '关闭标签',
  closeOther: '关闭其他',
  closeLeft: '关闭左侧',
  closeRight: '关闭右侧',
  confirm: '确认',
  cancel: '取消',
  operate: '操作',
  submit: '提交',
  back: '返回',
  show: '显示',
  hide: '隐藏',
  open: '开启',
  close: '关闭',
  enable: '启用',
  disable: '禁用',
  ok: '确定',
  copy: '复制',
  copySuccessfully: '复制成功',
  copyFailed: '复制失败',
  maximize: '最大化',
  exitMaximized: '退出最大化',
  totalNum: '共{{num}}条数据',
  name: '名称',
  creationTime: '创建时间',
  updateTime: '更新时间',
  columnFilter: '列筛选',
  refresh: '刷新',
  refreshSuccessfully: '刷新成功',
  notSearchContent: '暂无搜索内容',
  switch: '切换',
  content: '内容',
  title: '标题',
  type: '类型',
  refreshPage: '刷新页面',
  returnHome: '返回首页',
  pageErrorTitle: '页面出现错误',
  reloadPageMsg: '发现新内容，自动更新中...',
  pagepageErrorSubTitle: '抱歉，页面出现了错误，无法正常显示内容。',
  notPermissionMessage: '当前页面无法访问，可能没权限或已删除!',
  notFindMessage: '当前页面无法访问，可能没权限或已删除',
  requiredForm: '{{label}}为必填项',
  validateEmail: '{{label}}不是邮箱格式！',
  validateNumber: '{{label}}不是数字格式！',
  validateRange: '{{label}}必须大于{{min}}且小于{{max}}',
  createMethodWarning: '新增组件缺少对应方法',
  getPageWarning: '缺少获取页面方法',
  tableSelectWarning: '请勾选表格数据',
  menuSearchPlaceholder: '请输入菜单名称',
  noMoreData: '没有更多数据',
  noLoginVisit: '未登录无法访问',
  loading: '加载中',
  uploadFile: '上传文件',
};
